module.exports = __webpack_public_path__ + "static/img/title-acn.4f9748bd.png";